import { render, staticRenderFns } from "./TraxAccountUserEditRights.vue?vue&type=template&id=e51ca5d6"
import script from "./TraxAccountUserEditRights.vue?vue&type=script&lang=js"
export * from "./TraxAccountUserEditRights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports